import { connect } from 'react-redux';
import ProductListFilter from '../components/ProductList/ProductListFilter';
import {
    getAvailableSortBy,
    getSelectedFilters,
    getSelectedSortBy,
    getSelectedListStyle,
    getShowNLISFilter,
    getShowNAITFilter,
} from '../selectors/productSelector';
import {
    updateLivestockFilter,
    setSort,
    setViewBy,
} from '../actions/productActions';

const mapStateToProps = function(store) {
    return {
        hasLiveStockFilter: store.product.hasLiveStockFilter,
        selectedFilters: getSelectedFilters(store.product),
        selectedSortBy: getSelectedSortBy(store.product),
        selectedListStyle: getSelectedListStyle(store.product),
        availableSortBy: getAvailableSortBy(),
        showNLISFilter: getShowNLISFilter(store),
        showNAITFilter: getShowNAITFilter(store),
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        updateLivestockFilter: (key, value) =>
            dispatch(updateLivestockFilter(key, value)),
        updateSortBy: (key, value) => dispatch(setSort(key, value)),
        updateListStyle: (value) => dispatch(setViewBy(value)),
    };
};
const ConnectedProductListFilter = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductListFilter);

export default ConnectedProductListFilter;
